import Vue from "vue";
import DateTimePicker from "vuetify-datetime-picker";

Vue.use(DateTimePicker);

export default DateTimePicker;
